// extracted by mini-css-extract-plugin
export default {"input":"InputNew_input__q4JY8","error":"InputNew_error__izlEA","isValid":"InputNew_isValid__6GjAb"};